import React from "react";
import {Space, notification, Input, Button } from "antd";
import store from "../../store/global";
import {getToken, getQuery} from "../../api/gptgo";
import {Observer} from "cellx-react";


const { TextArea } = Input;

@Observer
class Header extends React.Component<any, any>{

    async loadData() {
        if (!store.query)
            return;

        store.globalLoading = true;
        try {
            store.result = await getQuery(await getToken(store.query));
        } catch (e) {
            notification.error({
                // @ts-ignore
                description: e.message ? e.message : 'No Data.',
                message: 'Error!',
            });
        }
        store.globalLoading = false;
    }

    render() {
        return (
            <Space className="app-header">
                <TextArea style={{minWidth: 1000}}
                          autoSize={{minRows: 6}}
                          placeholder="Вопрос или Promt к GPT"
                          onChange={(e) => store.query = e.target.value}
                          disabled={store.globalLoading}
                />
                <Button onClick={()=> this.loadData()}
                        loading={store.globalLoading}
                        disabled={store.globalLoading}
                > Запрос </Button>
            </Space>
        );
    }
}

export default Header;
